import Quill from 'quill'; // <-- import directly from 'quill'

let hasRegisteredHashtagBlot = false;

export function registerHashtagBlot() {
  if (hasRegisteredHashtagBlot) return;
  console.warn('registerHashtagBlot - registering blot');

  const Inline = Quill.import('blots/inline');

  class HashtagBlot extends Inline {
    static create(value: string) {
      const node = super.create();
      node.setAttribute('data-tag', value);
      node.classList.add('creatorHashtag');

      return node;
    }

    static formats(node: HTMLElement) {
      return node.getAttribute('data-tag');
    }
  }

  HashtagBlot.blotName = 'creatorHashtag';
  HashtagBlot.tagName = 'span';
  HashtagBlot.className = 'creatorHashtag';

  Quill.register(HashtagBlot);
  hasRegisteredHashtagBlot = true;
}
